<template>
<!--已购产品-->
  <div class="PurchasedProduct">
    <a-spin :spinning="spin">
      <div class="bottom">
        <!-- 顶部 -->
        <div style="border: 1px solid #edeff2; margin-bottom: 15px">
          <div class="moTitle">
            <div class="topTitle font">服务咨询列表</div>
          </div>
        </div>
        <a-table :columns="columns" :data-source="data" :pagination="false">
        </a-table>
      </div>

      <!-- 分页 -->
      <div style="display: flex; justify-content: center; margin-top: 20px">
        <a-pagination
            :current="pagination.curPage"
            :total="pagination.total"
            :pageSize="pagination.pageSize"
            show-quick-jumper
            @change="PageNOchange"
        />
      </div>
    </a-spin>
  </div>
</template>

<script>
import variables from "@/assets/base.scss";
import {
  cancellationByOrderNumber,
  delServiceConsultList,
  selectRecordList,
  serviceConsultList
} from "@/service/authentication";

const columns = [
  {
    title: '序号',
    key: 'rank',
    scopedSlots: { customRender: 'rank' },
  }, {
    title: '名称',
    dataIndex: 'serviceName',
    key: 'serviceName',
  },{
    title: '数量/单位',
    dataIndex: 'quantity',
    key: 'quantity',
  },{
    title: '剩余数量/单位',
    dataIndex: 'numberRemaining',
    key: 'numberRemaining',
    scopedSlots: { customRender: 'numberRemaining' },
  },{
    title: '有效期',
    dataIndex: 'validity',
    key: 'validity',
  },{
    title: '开始日期',
    dataIndex: 'startDate',
    key: 'startDate',
    scopedSlots: { customRender: 'startDate' },
  },{
    title: '结束日期',
    dataIndex: 'endDate',
    key: 'endDate',
    scopedSlots: { customRender: 'endDate' },
  },
  {
    title: '操作',
    key: 'action',
    scopedSlots: { customRender: 'action' },
  },
];
const data = [];
export default {
  name: "PurchasedProduct",
  components: {
  },
  data() {
    return {
      spin: false,
      visible: false,
      pagination:{
        curPage:1,
        pageSize:10,
        total:0,
      },
      data,
      columns,
    };
  },
  created() {
  },
  methods: {
  }
};
</script>

<style scoped lang="scss">
.ant-col-5 {
  width: 20%;
}
.ant-col-4 {
  width: 16.66666%;
}

.PurchasedProduct {
  width: 100%;
  min-height: 100%;
  border: 10px solid #edeff2;
}
.top {
  width: 100%;
  height: 50px;

  .selectTop {
    width: 98%;
    height: 50%;
    margin: auto;
    display: flex;
    line-height: 30px;
    margin-top: 15px;
  }
}
.topTitle {
  color: $topTitleColor;
}

.bottom {
  width: 100%;
  min-height: 480px;
}

.moTitle {
  display: flex;
  justify-content: space-between;
  width: 98%;
  margin: auto;
  height: 50px;
  line-height: 50px;
  .font {
    font-weight: 600;
    color: $topNameColor;
  }
}

</style>
